import { render, staticRenderFns } from "./SlidesList.vue?vue&type=template&id=78b49ba0&scoped=true"
import script from "./SlidesList.vue?vue&type=script&lang=js"
export * from "./SlidesList.vue?vue&type=script&lang=js"
import style0 from "./SlidesList.vue?vue&type=style&index=0&id=78b49ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b49ba0",
  null
  
)

export default component.exports